export const ITEM_ID_VS_VIEW_SEGMENT_EVENTS = {
  articles: 'view_articles_page',
  news: 'view_news_page',
  reviews: 'view_reviews_page',
}

export const ITEM_ID_VS_VIEW_LISTING_SEGMENT_EVENTS = {
  articles: 'view_articles_listing_page',
  news: 'view_news_listing_page',
  reviews: 'view_reviews_listing_page',
}
